import React from 'react'
import { Row, Col, Form, FormControl } from 'react-bootstrap'
import { StarFill } from 'react-bootstrap-icons'
import useViewport from '../../../hooks/use-viewport'

const InputComponent = ({
    value = 1,
    onChange = () => {}
}) => {
    const { breakpoint, breakpoints } = useViewport()
    const onValueChange = (val) => {
        if (val < 0) {
            val = 0
        }
        onChange(val)
    }

    return (
        <Form.Group as={Row} controlId="formHorizontalEmail">
            <Form.Label column sm={12} md={1} lg={2} xl={6}>
                <StarFill size={30} /> {breakpoint >= breakpoints.XL || breakpoint <= breakpoints.SM ? 'Units' : ''}
            </Form.Label>
            <Col sm={12} md={11} lg={10} xl={6}>
                <FormControl type='number' value={value} onChange={e => onValueChange(e.target.value)} />
            </Col>
        </Form.Group>
    )
}

export default InputComponent